import 'phoenix_html';
import { Socket } from 'phoenix';
import { LiveSocket } from 'phoenix_live_view';
import hooks from './hooks';
import { bindShellChrome } from './shell/chrome.ts';
import { bindWorkspaceContext } from './shell/workspace-context.ts';
import { bindAssistantHandoff } from './assistant/handoff.ts';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const csrfToken = document
  .querySelector("meta[name='csrf-token']")!
  .getAttribute('content');

const liveSocket = new LiveSocket('/live', Socket, {
  hooks,
  longPollFallbackMs: 2500,
  params: { _csrf_token: csrfToken },
});

bindShellChrome();
bindWorkspaceContext();
bindAssistantHandoff();

liveSocket.connect();

// Console debug / latency simulation: liveSocket.enableDebug(), enableLatencySim(1000)
window.liveSocket = liveSocket;
